const paths = {
  console: '/console'
};

export default paths;
